import React, { useState } from 'react';
import Navigation from '../../Components/Navigation';
import MobileRechargeContext from '../../Context/MobileRechargeContext';
import GrowYourBussion from '../../Components/GrowYourBussion/GrowYourBussion';
import AboutPay2Mobile from '../../Components/AboutPay2Mobile';
import DownloadPay2Mobile from '../..//Components/DownloadPay2Mobile';
import FooterContent from '../../Components/Footer/footer-content';
import { useLocation } from 'react-router-dom';
import SEO from '../../Components/SEO/SEO';

export default function Homepage() {
	const [planDetails, setPlanDetails] = useState({});
	const [planAmount, setPlanAmount] = useState('');
	const [selectedRechargeDetails, setSelectedRechargeDetails] = useState({});
	
	return (
		<>
		      <SEO
			 title="Secure Payments for AEPS, DMT, Bill Payments & Recharges | Pay2Mobiles"
			 description="Make secure and fast payments with Pay2Mobiles. Simplify your AEPS, DMT, bill payments, and recharge transactions using our reliable and user-friendly payment platform"
			 keywords="Payment Page, Secure Payments, AEPS Payments, DMT Transactions, Bill Payment Platform, Recharge Payments, Digital Payments, Pay2Mobiles Transactions, Online Payment Gateway, Fast and Secure Transactions"
			  />
			<div className="container">
				<div className="Home-page">
					<MobileRechargeContext.Provider value={{ planDetails, setPlanDetails, planAmount, setPlanAmount, selectedRechargeDetails, setSelectedRechargeDetails }}>
						<Navigation />
					</MobileRechargeContext.Provider>
				</div>
			</div>
			<AboutPay2Mobile />
			<FooterContent />
			<GrowYourBussion />
			<DownloadPay2Mobile />
		</>
	);
}
